
import { defineComponent, ref, useContext } from '@nuxtjs/composition-api'
import { LocaleObject } from 'nuxt-i18n'
import { getCountryCode } from '~/assets/ts/Locale'

export default defineComponent({
  components: {},
  setup() {
    const {
      app: { i18n },
    } = useContext()

    const languageDetected = ref('')
    const country: string = getCountryCode()

    if (process.client && country === 'be') {
      const language = i18n.locale || 'de'
      const browserLanguage = window.navigator.language.substr(0, 2)

      if (language !== browserLanguage) {
        for (const possibleLanguageIdx in i18n.locales) {
          const possibleLanguage = i18n.locales[
            possibleLanguageIdx
          ] as LocaleObject
          if (browserLanguage === possibleLanguage.code) {
            languageDetected.value = browserLanguage
          }
        }
      }
    }

    return {
      languageDetected,
    }
  },
})
